
import moment from 'moment-timezone'
import TestAccountLinks from '~/components/brokerage-hr/TestAccountLinks.vue'
import { copyText } from '~/util/brokerage-hr'

export default {
    components: { TestAccountLinks },
    data () {
        return { loading: false, items: [], links: {} }
    },
    mounted () {
        this.load()
    },
    methods: {
        rowKey (item) {
            return `${item.appointment_id}-${item.client_id || 'none'}`
        },
        when (start) {
            return `${moment.tz(start, 'America/New_York').format('ddd MMM D, h:mm A')} ET`
        },
        async load () {
            this.loading = true
            const res = await this.$try('getFeedbackPilotAppointments', { days: 14 })
            this.loading = false
            if (!res || res.error) return
            this.items = res.items
        },
        async copyLink (item) {
            const res = await this.$try('makeFeedbackPilotLink', { appointment_id: item.appointment_id, client_id: item.client_id })
            if (!res || res.error) return
            // Shown as well as copied: some browsers refuse a copy after an await.
            this.$set(this.links, this.rowKey(item), res.url)
            await copyText(this.$store, res.url)
        },
    },
}
